import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InputField from '../Reusable/InputField';
import { SubmitButton } from '../../enums/GlobalEnums';
import { ModalForAddOrUpdateProductCategory } from '../../enums/ProductCategoryEnums';

const ModalForUpdateProductCategory = ({
  category,
  updateProductCategory,
  handleClose,
  show,
  productCategoryReducer,
}) => {
  const [productCategoryName, setProductCategoryName] = useState(category.productCategoryName);
  const { error } = productCategoryReducer;

  const onChange = (e) => {
    setProductCategoryName(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const updatedProductCategory = {
      id: category.id,
      productCategoryName,
    };
    updateProductCategory(updatedProductCategory);
  };

  return (
    <Dialog open={show} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {ModalForAddOrUpdateProductCategory.titleForUpdateProductCategory}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <InputField
          name="productCategoryName"
          placeholder={ModalForAddOrUpdateProductCategory.productCategoryNamePlaceholder}
          onChange={onChange}
          value={productCategoryName}
          error={error?.productCategoryName}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          {SubmitButton.update}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalForUpdateProductCategory;
